import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import queryString from 'query-string';

import Link from 'next/link'
import { Button } from 'antd';
import {useRouter} from 'next/router';
import Icon from "@ant-design/icons";
import LogoWithText from "../../public/filestore/logo_with_text";
import UserHeader from "../../components/UserHeader/UserHeader";
import Footer from "../../components/Footer/Footer";

function Error500(props) {
    const router = useRouter();
    const [pathName, setPathName] = useState(null);

    useEffect(() => {
        setPathName(router.asPath);
        console.log(pathName, router.asPath, window.location.pathname)
        if(pathName && pathName !== router.asPath){
            setPathName(router.asPath);
            router.push(router.asPath);
            router.reload();
        }
    },[router.asPath]);

    const handleReload = () => {
        window.location.reload();
    }
    const onUnload = () => {
       window.location.href = "/";
    }
    
    console.log('here I am',props.history, router.asPath)
    return (
        <div id='error500'>
            {/*<div className="error500_sub-header"></div>*/}
                {(props.statusCode === 500 || props.isError500) &&
                    <div className="error500_body">
                        <div>
                            <p className='headings'>Sorry, looks like a momentary network glitch!</p>
                            <p className='paragraph'>Please refresh the page to get back to what you were doing.</p>
                            <p className='paragraph error-page-refresh-btn'>
                            {props.path ?
                                <Button type="link" onClick={handleReload} > REFRESH </Button> :
                                <Button className="qa-button" type="link" onClick={() => {window.location.reload();}} > REFRESH </Button>
                            }
                            </p>
                        </div>
                    </div>
                }
                {props.error && !(props.statusCode === 500 || props.isError500) &&
                    <div className="error500_body">
                        <div>
                            <p className='headings'>Sorry, looks like something is wrong!</p>
                            <p className='paragraph'>Our engineers are on top of it. Please try again after sometime!</p>
                        </div>
                    </div>
                }
                    {/*<div className="error500_body">
                        <div>
                            <p className='headings'>Sorry, looks like something is wrong!</p>
                            <p className='paragraph'>Our engineers are on top of it. Please try again in a few minutes!</p>
                        </div>
                    </div>*/}
        </div>
    )
}

const mapStateToProps = (state) => {
  return {
    isError500: state.checkout.isError500
  }
};

export default connect(mapStateToProps, null)(Error500);